// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-U":"U_dpu-detail-U__u31ZF"};